import ListarUsuariosTenant from '@/features/users/components/lista-user'

export function ListarParceirosPage() {
  return <ListarUsuariosTenant />
}
